import { TrackingManager } from "./trackingManager"

export default () => {
  // TrackPageView event
  window.addEventListener("pageshow", () => {
    const trackingConfig = window.trackingConfig

    if (
      trackingConfig &&
      trackingConfig.enabledTrackingServices &&
      trackingConfig.enabledTrackingServices.length > 0
    ) {
      const isTranslationMode = new URLSearchParams(window.location.hash.substring(1)).get(
        "translation_token",
      )
      const store = window.Alpine.store("data")
      const storeData = (store && store.values) || {}
      const data = { segmentUserId: storeData.segmentUserId || "" }

      // Do not log page view if translation mode is active or no store data is available
      if (isTranslationMode) return

      const tracker = new TrackingManager(trackingConfig.enabledTrackingServices, pipelineConfig)
      const serviceSettings = trackingConfig.serviceSettings || {}
      const enabledServices = trackingConfig.enabledTrackingServices || {}
      const restrictedPageViewServices = Object.keys(serviceSettings).filter(
        (key) => serviceSettings[key].restrictPageViewEnabled === true,
      )
      const resetUserDataServices = Object.keys(serviceSettings).filter(
        (key) => serviceSettings[key].resetUserData === true,
      )

      // Reset user data
      if (resetUserDataServices.length > 0) {
        resetUserDataServices.forEach((service) => {
          tracker.resetUserData(service)
        })
      }

      if (restrictedPageViewServices.length > 0) {
        // If we got restricted services, we only track page view for services that are not restricted
        enabledServices.forEach((service) => {
          if (!restrictedPageViewServices.includes(service)) {
            // For segment track even though aint identified
            if (service === "segment") {
              tracker.trackPageView(service)
            }

            tracker.isUserIdentified(data, service).then((isIdentified) => {
              if (isIdentified) {
                tracker.trackPageView(data, service)
              }
            })
          }
        })
      } else {
        // Track page view for all enabled services
        enabledServices.forEach((service) => {
          if (service === "segment") {
            tracker.trackPageView({}, service) // Cause segment will identify user on pageView event anyway - otherwise for NPS segmentUserID ain't existant
            return
          }

          tracker.isUserIdentified(data, service).then((isIdentified) => {
            if (isIdentified) {
              tracker.trackPageView(data, service)
            }
          })
        })
      }
    }
  })

  // TrackClick event from store
  window.addEventListener("pageshow", () => {
    const trackingConfig = window.trackingConfig
    const klaviyoTrackEventsList = sessionStorage.getItem("klaviyoTrackEventsList")

    if (klaviyoTrackEventsList && klaviyoTrackEventsList.length > 0) {
      if (
        trackingConfig &&
        trackingConfig.enabledTrackingServices &&
        trackingConfig.enabledTrackingServices.length > 0
      ) {
        const isTranslationMode = new URLSearchParams(window.location.hash.substring(1)).get(
          "translation_token",
        )

        if (isTranslationMode) return

        const tracker = new TrackingManager(trackingConfig.enabledTrackingServices, pipelineConfig)
        let events = JSON.parse(klaviyoTrackEventsList)

        // Iterate over all events and track them and remove them from sessionStorage 1 by 1
        while (events.length > 0) {
          const eventPayload = events.shift()
          tracker.trackSessionStorageClickEvent(eventPayload)
          sessionStorage.setItem("klaviyoTrackEventsList", JSON.stringify(events)) // Update sessionStorage
        }
      }
    }
  })
}
